// Parent emails come back from the API as an array — they live on the student's
// profile, not the roster row — but are typed as free text so one student can
// have both parents. These helpers accept either shape, since a field being
// edited holds the raw text until it is saved and reloaded.

// Mirrors the server's check (server/utils/parentEmails.js) so a typo is caught
// before saving. A wrong address means the parent never gets their portal login
// and nothing tells them why.
const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

export const parentEmailsToText = (value) =>
  Array.isArray(value) ? value.join(', ') : (value ?? '');

export const splitParentEmails = (value) =>
  (Array.isArray(value) ? value : String(value ?? '').split(/[,;\n]/))
    .map((email) => String(email).trim())
    .filter(Boolean);

export const invalidParentEmails = (value) =>
  splitParentEmails(value).filter((email) => !EMAIL_PATTERN.test(email));

/**
 * Returns `{ name, invalid[] }` for every student with a malformed address, so
 * a save can be blocked with a message naming the child to fix.
 */
export const findStudentsWithInvalidParentEmails = (students = []) =>
  students
    .map((student) => ({
      name: student.name || 'Unnamed student',
      invalid: invalidParentEmails(student.parentEmails),
    }))
    .filter((entry) => entry.invalid.length > 0);
